import { FC } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { cn } from '@bem-react/classname'
import parse from 'html-react-parser'

import { Checkbox } from '@/components/Form/Checkbox'
import { Tag } from '@/components/UI/Tag'

import { RegisterFinishModel } from '../../models/Register.model'
import './FinishStep.scss'

interface IFinishStepProps {
  className?: string
}

const cnFinishStep = cn('FinishStep')

export const FinishStep: FC<IFinishStepProps> = ({ className }) => {
  const { t } = useTranslation()

  const {
    control,
    formState: { errors },
  } = useFormContext<RegisterFinishModel>()

  return (
    <div className={cnFinishStep(null, [className])}>
      <Tag className={cnFinishStep('title')}>{t('register-six-title')}</Tag>
      <div className={cnFinishStep('wrap')}>
        <div className={cnFinishStep('small')}>{t('register-small-title')}</div>
        <div className={cnFinishStep('label')}>
          {t('register-small-label-1')}
        </div>
        <div className={cnFinishStep('label')}>
          {t('register-small-label-2')}
        </div>
      </div>

      <div className={cnFinishStep('text')}>
        {parse(t('register-six-text'))}
      </div>

      <div className={cnFinishStep('checkboxes')}>
        <Controller
          name='confirm'
          control={control}
          render={({ field: { name, value, onChange } }) => (
            <Checkbox
              id={name}
              name={name}
              checked={value}
              onChange={onChange}
              errors={errors.confirm?.message}
            >
              {t('register-privacy-consent')}
            </Checkbox>
          )}
        />
      </div>
    </div>
  )
}
